import * as React from "react";
import { forwardRef } from "react";
const LogoFacebookSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M13.636 22H9.182v-9.957H7V8.58h2.182V6.502C9.182 3.732 10.454 2 14 2h3v3.463h-1.818c-1.364 0-1.455.52-1.455 1.385V8.58H17l-.364 3.463h-3z" }));
const ForwardRef = forwardRef(LogoFacebookSVG);
export default ForwardRef;
//# sourceMappingURL=LogoFacebook.js.map